module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJ1BMVEXd3d3g4ODd3d3////l5eX7+/v5+fn29vbu7u7p6eni4uLy8vLq6urNe1QDAAAAAnRSTlPjSQzAlCMAAAB/SURBVBjTYxBQggNGBiYER4FBCQlAOCpOSBz1IiSOswkSp9gcwVExNnaCcTzbjI0zpoA5WsHGYGC6CCTjCuGEgJWpBIMlnCB6XCESEI4OiHMIytEAcZqgHG0QZxOUo2ZsXmycBOUomzmpJBtBOcsmKSlpZoE5MICXgxIgKEEFAGMuMIzg8NelAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/star_none.png
// module id = Hbee
// module chunks = 0